// extracted by mini-css-extract-plugin
module.exports = {"step":"style_step__H8kpw","badge":"style_badge__Y3gWc","task":"style_task__QGOrh","cta":"style_cta___EYDK"};